import useSourceCentricDetailsFlag from '../data-service/useSourceCentricDetailsFlag'
import { CLASSIC_GUTTERS, PERSON_BAND_CLASSIC_GUTTERS, SOURCE_CENTRIC_GUTTERS } from '../person-page/constants'

type Gutters = {
  marginX: typeof PERSON_BAND_CLASSIC_GUTTERS | typeof SOURCE_CENTRIC_GUTTERS
  marginY: typeof CLASSIC_GUTTERS | typeof SOURCE_CENTRIC_GUTTERS
}

/**
 * The horizontal and vertical gutters a focus-person sub-page uses, which differ under source-centric
 * details. Shared by `SubPersonPageDecorator` and `SubPersonPageDecoratorSkeleton` so the loading
 * chrome cannot drift from the loaded chrome.
 */
export default function useSubPersonPageGutters(): Gutters {
  const isSourceCentricOn = !!useSourceCentricDetailsFlag().data?.isOn

  return {
    marginX: isSourceCentricOn ? SOURCE_CENTRIC_GUTTERS : PERSON_BAND_CLASSIC_GUTTERS,
    marginY: isSourceCentricOn ? SOURCE_CENTRIC_GUTTERS : CLASSIC_GUTTERS,
  }
}
